// profileDb.ts copyright 2021-2024 Rebecca Beaudet
import { writable } from 'svelte/store';
import { BACKEND_URL, SIGN_UP_LAG } from '../language/connectionConst';
import { pdVideos, videoReqLag } from '../language/videoContent';
import { getDb } from './indexedDb';
const blankProfile = {
    id: '1',
    name: '',
    email: '',
    password: '',
    authTTL: 0,
    signUpTime: 0,
    lastPurchaseTime: 0,
};
let blockVideoFetch = false; // only get videos once
const profile = writable(blankProfile);
// use cryptographically secure generated values
// Reason: if someone reverse engineers Math.random() in users context its deterministic.
// Reverse engineering crypto.getRandomValues() is going to be harder to crack
const generatePassword = (length = 15) => {
    const charset = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789@#$';
    const PWarray = new Uint32Array(length);
    window.crypto.getRandomValues(PWarray);
    return Array.from(PWarray, (num) => charset[num % charset.length]).join('');
};
const getProfile = async () => {
    const db = await getDb();
    const user = await db.get('profiles', '1');
    if (user)
        profile.set(user);
    else
        videoReqLag.set(false);
};
const upsertProfile = async (userUpdates) => {
    const db = await getDb();
    const existingUser = await db.get('profiles', '1');
    let upsertedUser = blankProfile;
    if (existingUser) {
        upsertedUser = Object.assign(Object.assign({}, existingUser), userUpdates);
    }
    else {
        // user creation (email and name required)
        blockVideoFetch = true;
        upsertedUser = Object.assign(Object.assign(Object.assign({}, blankProfile), userUpdates), { password: generatePassword() });
    }
    await db.put('profiles', upsertedUser);
    profile.set(upsertedUser);
    return upsertedUser;
};
const getPDVideos = async (email, password) => {
    try {
        const res = await fetch(`${BACKEND_URL}prod/getPDVideos`, {
            method: 'POST',
            body: JSON.stringify({ email, password }),
            headers: {
                'Content-Type': 'application/json',
            },
        });
        if (res.status !== 200) {
            console.error(`unexpected api code: ${res.status}`);
            return;
        }
        const { links, authTTL } = await res.json();
        // Only bother if there are links to update
        if (!(links === null || links === void 0 ? void 0 : links.length))
            return;
        pdVideos.update((videos) => {
            return videos.map((video) => {
                for (const link of links) {
                    if (video.id === Number(link.id)) {
                        return Object.assign(Object.assign({}, video), { link: link.link });
                    }
                }
                return video;
            });
        });
        videoReqLag.set(false);
        blockVideoFetch = true;
        if (authTTL)
            upsertProfile({ authTTL });
    }
    catch (err) {
        console.error(new Error(err));
    }
};
// get profile will trigger in app.svelte this will run once on page load
profile.subscribe(({ email, password, lastPurchaseTime }) => {
    if (blockVideoFetch || !email || !password)
        return;
    // given that a purchase has occurred in the past an it has had time to take
    const lastPurchase = lastPurchaseTime ? Date.now() - lastPurchaseTime : 0;
    if (!lastPurchase)
        return;
    if (lastPurchase > SIGN_UP_LAG) {
        getPDVideos(email, password);
    }
    else {
        setTimeout(() => {
            getPDVideos(email, password);
        }, SIGN_UP_LAG - lastPurchase);
    }
});
export { profile, getProfile, upsertProfile };
